import React, { Component } from "react";
import DataTableComponent from "../components/data/DataTableComponent";
export class ArticlesTableContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { formattedData, isUpdating, role, noSearch, headCells } = this.props;

    const defaultHeadCells = [
      { id: "title", rightAlign: false, label: "Title" },
      { id: "status", rightAlign: true, label: "Status" },
      { id: "author", rightAlign: true, label: "Author" },
      { id: "postDate", rightAlign: true, label: "Posted" },
      {
        id: "updated",
        rightAlign: true,
        label: "Last update",
        doNotShowInMobile: true,
      },
    ];

    return (
      <DataTableComponent
        noSearch={noSearch}
        role={role}
        isUpdating={isUpdating}
        data={formattedData}
        headCells={headCells ? headCells : defaultHeadCells}
        {...this.props}
      />
    );
  }
}

export default ArticlesTableContainer;
